import React from 'react';
import { Zap } from 'lucide-react';
import { useLanguage } from '../contexts/language-context';

interface LogoProps {
  className?: string;
}

const Logo = ({ className = '' }: LogoProps) => {
  const { getUrl } = useLanguage();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <a href={getUrl('/')}>
        <Zap className="w-8 h-8 text-neon-green-light dark:text-neon-green" />
      </a>
      <div className="font-bold text-2xl">
        <span className="text-neon-green-light dark:text-neon-green">Feen</span>
        <span className="text-neon-yellow-light dark:text-neon-yellow">nex</span>
      </div>
    </div>
  );
};

export default Logo;